/**
 * 解析当前运行环境是否为 iOS / Android in-app WebView。
 * 供 `portfolioFilePickStrategy` 与 `portfolioPickConfig` 使用。
 */
import { getBridge } from "@/src/lib/bridge/bridge";
import type { ResolvePortfolioPickConfigOptions } from "./portfolioPickConfig";

export function resolvePortfolioInAppPlatformFlags(): ResolvePortfolioPickConfigOptions {
  const bridge = getBridge();
  const inApp = bridge.isInApp();
  const platform = inApp ? bridge.getPlatform() : "web";
  return {
    isIosInApp: inApp && platform === "ios",
    isAndroidInApp: inApp && platform === "android",
  };
}
